import { useAppSelector } from '../../../hooks';
import TodoTabs from './TodoTabs';
import { getTodoList } from './TodoSlice';
import { Container, Spinner } from 'reactstrap';

const TodoList = () => {
    const todo = useAppSelector(getTodoList);
    const loading = useAppSelector((state) => state.todo.loading);

    return (
        <Container>
            {loading ? (
                <div style={{ flex: 1, justifyContent: 'center' }}>
                    <Spinner 
                        color="primary"
                        style={{ width: '3rem', height: '3rem'}}
                    />
                </div>
            )
            : (
                <div style={{ flex: 1 }}>
                    <TodoTabs 
                        todo={todo}
                        sticky={true}
                        stickyTop={60}
                    />
                </div>
            )}
        </Container>
    )

};

export default TodoList;